const strings = {
	en: {
		title: 'Legal information',
	},
	es: {
		title: 'Información legal',
	}
}

export default strings;